import { useContext } from 'react'
import { TripContext } from 'contexts';
import { CompanyEmail } from './types/companyEmail';

const emailsMatch = (left: CompanyEmail, right: CompanyEmail): boolean =>
    left.companyId === right.companyId &&
    left.email === right.email &&
    left.isPredelivery === right.isPredelivery &&
    left.isPostdelivery === right.isPostdelivery

export const useEmailService = () => {
    const tripContext = useContext(TripContext);

    const addEmailToContext = (email: string, isPredelivery: boolean, isPostdelivery: boolean, companyId: string) => {
        const newEmail: CompanyEmail = {
            id: Date.now(),
            companyId: companyId,
            email: email,
            isPredelivery: isPredelivery,
            isPostdelivery: isPostdelivery,
        };

        const deletionToRemove = tripContext.companyEmailDeletions.find(existing => emailsMatch(existing, newEmail));
        if (deletionToRemove) {
            tripContext.companyEmailDeletions.remove(deletionToRemove.id);
        } else {
            const alreadyTracked = tripContext.companyEmailAdditions.find(existing => emailsMatch(existing, newEmail));
            if (!alreadyTracked) {
                tripContext.companyEmailAdditions.put(newEmail);
            }
        }

        tripContext.companyEmail.put(newEmail);
    };

    const deleteEmailFromContext = (id: number) => {
        const emailToDelete = tripContext.companyEmail.get(id);
        if (!emailToDelete) {
            return;
        }

        tripContext.companyEmail.remove(id);

        const additionEntry = tripContext.companyEmailAdditions.get(id);
        if (additionEntry) {
            tripContext.companyEmailAdditions.remove(id);
            return;
        }

        const deletionExists = tripContext.companyEmailDeletions.find(existing => emailsMatch(existing, emailToDelete));
        if (!deletionExists) {
            tripContext.companyEmailDeletions.put({ ...emailToDelete, id: emailToDelete.id ?? Date.now() });
        }
    };

    return {
        addEmailToContext,
        deleteEmailFromContext
    };
};

